"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TestBackend", {
  enumerable: true,
  get: function () {
    return _implementation.default;
  }
});
Object.defineProperty(exports, "AuthenticationPage", {
  enumerable: true,
  get: function () {
    return _AuthenticationPage.default;
  }
});
exports.NetlifyCmsBackendTest = void 0;

var _implementation = _interopRequireDefault(require("./implementation"));

var _AuthenticationPage = _interopRequireDefault(require("./AuthenticationPage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const NetlifyCmsBackendTest = {
  TestBackend: _implementation.default,
  AuthenticationPage: _AuthenticationPage.default
};
exports.NetlifyCmsBackendTest = NetlifyCmsBackendTest;